<template lang='pug'>
.main-container
  
  .view-content
    el-card(v-if='request', class='el-card__with-bg')
      div(slot='header')
        i.mat-icon assignment
        router-link(to='/user/requests') Requests
        |  &gt;
        .request-name {{ request.name }}
        status-tag(:status='request.status')
        .secondary
          i.mat-icon date_range
          |  {{ $formatDate(request.delivery_date) }}
          .v-divider
          i.mat-icon access_time
          |  {{ $formatTime(request.delivery_time) }}
          .v-divider
          i.mat-icon person
          | {{ request.people }}
          .v-divider
          span {{$formatCents(request.budget_cents)}}/person
          .v-divider
          em  Request \#{{ request.id }}
      request(:request='request')
</template>

<script>
import Request from './blocks/Request.vue'
import StatusTag from '../common/StatusTag.vue'

function data ( )  {
  return {
    request: null,
    loading: true,
  }
}

function fetchData ( ) {
  this.$simplecater.get('/requests/' + this.$route.params.id).then((r)=>{
      let request = r.data.data
      request.estimates = _.sortBy(request.estimates, 'id');
      this.request = request
    }).catch(()=>{
      this.$message.error("Failed to load the request")
    })
}

function created ( ) {
  this.fetchData()
  this.$bus.$on('estimate-accepted', this.fetchData)
}

const methods = {
  fetchData
}

const components = { Request, StatusTag }

// TODO - Re-fetch on route change/update
export default { data, methods, created, components }
</script>

<style scoped lang="sass">
  .request-name
    display: inline-block
    font-weight: 600
    margin: 0 0.5rem
  .secondary
    // display: inline-block
    color: #888
    font-size: 0.8em
    margin-left: 1.7rem
    .v-divider
      display: inline-block
      width: 1px
      background: #ccc
      height: 1.5em
      margin: 0 0.5rem
      vertical-align: middle
</style>



// WEBPACK FOOTER //
// src/user/RequestDetail.vue